import { connect } from 'react-redux'
import { INSTRUMENT_TYPE_MAP } from 'utils/constants'
import { getBaseSiteIdFromStudy } from 'utils/misc'
import Loader from 'components/D3Loader'
import { metadataActions } from '../../../modules/Instrument'
import ScoringPage from '../components/ScoringPage'
import { scoringActions as clinroScoringActions } from '../../EditClinro/modules/Clinro'
import { scoringActions as surveyScoringActions } from '../../EditSurvey/modules/Survey'
import { scoringActions as diaryScoringActions } from '../../EditDiary/modules/Diary'
import { isVersionUatOrLive } from '../../../../../../../../../../../utils/studyConfigUtils'

const mapStateToProps = (
  { clinroEditor, diaryEditor, instrumentReducer, study, surveyEditor, loading, user },
  ownProps,
) => {
  const { studyVersionID } = ownProps?.params || {}
  const { clinro, clinroErrors } = clinroEditor || {}
  const { survey, surveyErrors } = surveyEditor || {}
  const { diary, diaryErrors } = diaryEditor || {}
  const { type } = instrumentReducer?.instrument || {}
  const isClinro = type === INSTRUMENT_TYPE_MAP.clinro
  const isDiary = type === INSTRUMENT_TYPE_MAP.diary
  const { studyVersionList } = study || {}

  const hasStudyPromotion = !!study?.currentStudy?.config?.study_promotion
  const isReadOnlyState = hasStudyPromotion && isVersionUatOrLive(studyVersionList, studyVersionID)

  return {
    clinro,
    clinroErrors,
    diary,
    diaryErrors,
    errors: instrumentReducer?.errors,
    isClinro,
    isDiary,
    studyID: study?.currentStudy?.id,
    siteID: getBaseSiteIdFromStudy(study),
    survey,
    surveyErrors,
    loading: loading?.general,
    isReadOnlyState,
    studyVersionID,
    displayScoreToParticipant: !!instrumentReducer?.instrument?.metadata?.display_score_to_participant,
  }
}

const mapDispatchToProps = {
  ...clinroScoringActions,
  ...metadataActions,
  ...surveyScoringActions,
  ...diaryScoringActions,
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(props => {
  if (props.loading) {
    return Loader(props)
  }
  return ScoringPage(props)
})
